<div
    class="panel"
    *ngIf="testSession"
>
    <div
        class="row"
        *ngIf="!isStudyMaterials"
    >
        <div class="col-sm-3">
            <h5>Test:</h5>
        </div>
        <div class="col-sm-9">
            <span [ngClass]="testTypeCssClass">{{testSession.testTypeDisplayName}} Test</span>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <h5>Test Date & Time:</h5>
        </div>
        <div class="col-sm-9">
            {{testDate | customDate: 'selectedTestFormatDateTime'}}
            <br *ngIf="testSession.isWebDelivery" />
            <span *ngIf="testSession.isWebDelivery">(Time Zone: {{localTimeZone}})</span>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <h5>Test Location:</h5>
        </div>
        <div class="col-md-4 col-lg-5">
            <div>
                {{testSession.testCentreName}}<br />
                <ng-container *ngIf="!testSession.isWebDelivery">
                    {{testSession.testCentreAddressLine1}}
                    <br *ngIf="!!testSession.testCentreAddressLine1" />
                    {{testSession.testCentreAddressLine2}}
                    <br *ngIf="!!testSession.testCentreAddressLine2" />
                    {{testSession.testCentreAddressLine3}}
                    <br *ngIf="!!testSession.testCentreAddressLine3" />
                    {{testSession.testCentreAddressLine4}}
                    <br *ngIf="!!testSession.testCentreAddressLine4" />
                    {{testSession.testCentreCity}}, {{testSession.testCentreRegion}} <span *ngIf="testSession.testCentrePostalCode.length > 0">{{testSession.testCentrePostalCode}}</span>
                </ng-container>
            </div>
        </div>
        <div
            class="col-md-5 col-lg-4 align-self-end my-2"
            *ngIf="isStudyMaterials"
        >
            <button
                type="button"
                class="btn btn-primary"
                (click)="redirectNextStep()"
            >Review Order & Pay</button>
        </div>
    </div>
    <div
        *ngIf="!isStudyMaterials"
        class="row justify-content-end"
    >
        <div
            *ngIf="!testSession.isWebDelivery"
            class="col-md-4 col-lg-6 pb-3"
        >
            <a
                href="http://maps.google.com?q={{testSession.testCentreName}}+{{testSession.testCentreAddressLine1 + testSession.testCentreAddressLine2 + testSession.testCentreAddressLine3}} {{testSession.testCentreCity}} {{testSession.testCentreRegion}}"
                class="link"
                target="_blank"
            >View location on Google Maps</a>
        </div>
        <div class="col-md-5 col-lg-3">
            <button
                type="button"
                class="btn btn-outline-primary"
                (click)="redirectTestSelection()"
            >Search again</button>
        </div>
    </div>
</div>
